import React from "react";
import { Row, Col } from "antd";
import { FaFacebookF, FaInstagram, FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import logo from "../images/logo.png";
import { Link } from "react-router-dom";
import { useSettings } from '../context/settingContext';
import SocialIcons from "./SocialIcons";

function Footer() {
  const { settings } = useSettings();

  return (
    <div className="bg-black">
      <div className="container mx-auto px-4">
        <footer className="bg-gradient-to-b from-white to-black text-white rounded-l-[42px] rounded-r-[42px]">
          <div className="max-w-7xl mx-auto px-4 py-10">
            <Row gutter={[32, 32]}>
              <Col xs={24} md={6}>
                <div className="flex items-center space-x-2 mb-4">
                  <Link to="/">
                    <img src={settings?.logo || logo} alt="Logo" />
                  </Link>
                </div>
                <p className="text-sm font-outfit text-black pt-4 pb-5">
                  {settings.footer_about}
                </p>
                <SocialIcons />
              </Col>
              <Col xs={24} md={6}>
                <h3 className="font-semibold mb-4 text-black font-syne">Main Links</h3>
                <ul className="space-y-2 text-sm">
                  <li><Link to="/" className="font-outfit text-black">Home</Link></li>
                  <li><Link to="/about" className="font-outfit text-black">About</Link></li>
                  <li><Link to="/shop" className="font-outfit text-black">Shop</Link></li>
                  <li><Link to="/contact" className="font-outfit text-black">Contact</Link></li>
                </ul>
              </Col>
              <Col xs={24} md={6}>
                <h3 className="font-semibold mb-4 text-black font-syne">Quick Links</h3>
                <ul className="space-y-2 text-sm">
                  <li><Link to="/terms-conditions" className="font-outfit text-black">Terms & Conditions</Link></li>
                  <li><Link to="/privacy-policy" className="font-outfit text-black">Privacy Policy</Link></li>
                  <li><Link to="/refund-policy" className="font-outfit text-black">Return Policy</Link></li>
                </ul>
              </Col>
              <Col xs={24} md={6}>
                <h3 className="font-semibold mb-4 text-black font-syne">Reach Us Out</h3>
                <ul className="space-y-2 text-sm">
                  <li className="flex items-center font-outfit text-black">
                    <FaMapMarkerAlt className="mr-2" />
                    <Link to="/">{settings?.address}</Link>
                  </li>
                  <li className="flex items-center font-outfit text-black">
                    <FaEnvelope className="mr-2" />
                    <Link to={`mailto:${settings?.email}`}>{settings?.email}</Link>
                  </li>
                  <li className="flex items-center font-outfit text-black">
                    <FaPhoneAlt className="mr-2" />
                    <Link to={`tel:${settings?.phone}`}>{settings?.phone}</Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </div>
          <div className="bg-black text-gray-400 text-sm text-center py-4 border-t border-gray-700 flex flex-row justify-between items-center px-4">
            <p className="font-outfit">{settings.footer_copyright}</p>
            <p className="font-outfit">
              Powered by{" "}
              <span className="text-white font-semibold">
                <Link to="https://designversestudios.com/" target="__blank">
                  Design Verse Studios
                </Link>
              </span>
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Footer;
